'use strict';
import angular from 'angular';
import _ from 'lodash';

import categoryFormHtmlUrl from '../views/categoryForm.html';

angular.module('product.categories.ctrls', [])
    .controller('ProductCategoryController', ['$scope', '$modal', '$ioAlert', '$confirm', '$state', 'ProductService', 'ProductCategoriesService', 'ClusterService', 'UserService', '$rootScope', 'filterFilter', function($scope, $modal, $ioAlert, $confirm, $state, ProductService, ProductCategoriesService, ClusterService, UserService, $rs, filterFilter) {
        $scope.productCategories = [];
        $scope.sortType = 'id';
        $scope.sortReverse = false;
        $scope.tapReportCategories = [
            {'id':'1', 'name':'Email Services'},
            {'id':'2', 'name':'Website / Landing Tracking Services'},
            {'id':'3', 'name':'SEO'},
            {'id':'4', 'name':'Social Services'},
            {'id':'5', 'name':'SEM/PPC Services'},
            {'id':'6', 'name':'Lead Tracking Services'},
            {'id':'7', 'name':'Display Services'},
            {'id':'8', 'name':'Local Listings'},];
        $scope.getProductCategories = function() {
            ProductCategoriesService.getCategories().then(function(success) {
                $scope.productCategories = success[0].productCategories;

                //set the ids as numbers to convert from strings for proper sorting
                if ($scope.productCategories.length > 0) {
                    for (var i = 0, len = $scope.productCategories.length; i < len; i++) {
                        $scope.productCategories[i].id = parseInt($scope.productCategories[i].id);
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve product categories.', 'error');
            });
        }
        $scope.getProducts = function() {
            ProductService.getAllProducts('no').then(function(success) {
                $scope.productIdsData = ProductService.products;
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve product categories.', 'error');
            });
        }

        // search based on user text
        $scope.updateSearch = function() {
            if ($scope.searchCategories) {
                $scope.filteredCategories = filterFilter($scope.productCategories, $scope.searchCategories);
            }
        };

        $scope.backtoProducts = function() {
            $state.go('products');
        };

        $scope.viewSaveCategory = function(productCategory) {
            $scope.isNew = (productCategory == null);
            $modal.open({
                controller: function($scope, $modalInstance, productCategory, productIdsData, tapReportCategories, ProductCategoriesService, $ioAlert) {
                    $scope.categoryObj = {};
                    $scope.productIdsData = productIdsData;
                    $scope.tapReportCategories = tapReportCategories;
                    if (productCategory) {
                        $scope.categoryObj.id = productCategory.id;
                        $scope.categoryObj.name = productCategory.name;
                        $scope.categoryObj.tapReportCategory = productCategory.report_category_id;
                        $scope.titleText = "Update";
                        ProductCategoriesService.getCategoryProducts(productCategory.id).then(function(response) {
                            $scope.categoryObj.productIds = response[0].products;
                        });

                    } else {
                        $scope.titleText = "Create New";
                    }

                    $scope.tagHandler = function(tag) {
                        return null;
                    };

                    $scope.save = function(productCategoryForm) {
                        if (productCategoryForm.$valid) {
                            if (productCategory) {
                                ProductCategoriesService.updateCategory($scope.categoryObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.productCategory) {
                                        $modalInstance.close(response.productCategory);
                                    }
                                }, function(error) {
                                    console.log("Error Update product Category");
                                });
                                var categoryObj = { categoryId: $scope.categoryObj.id, productIds: [] };
                                _.forEach($scope.categoryObj.productIds, function(obj) { categoryObj.productIds.push(obj.id); });

                                ProductCategoriesService.updateCategoryProducts(categoryObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                }, function(error) {
                                    console.log("Error adding products to Category");
                                });
                            } else {
                                ProductCategoriesService.addCategory($scope.categoryObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', "There was an error Adding the product Category");
                                        }
                                    } else {
                                        if (response.productCategory) {
                                            $modalInstance.close(response.productCategory);
                                            var categoryObj = { categoryId: response.productCategory.id, productIds: [] };
                                            _.forEach($scope.categoryObj.productIds, function(obj) { categoryObj.productIds.push(obj.id); });

                                            ProductCategoriesService.updateCategoryProducts(categoryObj).then(function(response) {
                                                if (response.errors) {
                                                    for (var i = 0, len = response.errors.length; i < len; i++) {
                                                        $ioAlert.show('Error', response.errors[i]);
                                                    }
                                                }
                                            }, function(error) {
                                                console.log("Error adding products to Category");
                                            });
                                        }
                                    }
                                }, function(error) {
                                    console.log("Error Adding product Category");
                                });
                            }
                        }
                    };
                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                },
                templateUrl: categoryFormHtmlUrl,
                resolve: {
                    productCategory: function() {
                        return productCategory;
                    },
                    productIdsData: function() {
                        return $scope.productIdsData;
                    },
                    tapReportCategories: function() {
                        return $scope.tapReportCategories;
                    }
                },
                backdrop: 'static'
            }).result.then(function(productCategoryObj) {
                if ($scope.isNew) {
                    $scope.productCategories.push(productCategoryObj);
                    $ioAlert.show('New Category', 'New Category has been added successfully', 'success');
                } else {
                    $scope.productCategories[$scope.productCategories.indexOf(productCategory)] = productCategoryObj;
                    $ioAlert.show('Update Category', 'Category has been updated successfully', 'success');
                }
            }, function(cancel) {

            });
        }

        $scope.viewRemoveCategory = function(productCategory) {
            var index = $scope.productCategories.indexOf(productCategory);
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Product Category?'
            }).then(function() {
                ProductCategoriesService.deleteCategory(productCategory).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show('Category Deleted', 'Product Category has been deleted successfully', 'success');
                        $scope.productCategories.splice(index, 1);
                    }
                });
            });
        }

        function adjustStickyHeader() {
            var parentWidth = $(".nav-content").width();
            $("#header").width(parentWidth);
            var childHeight = $("#header").height();
            $(".nav-content").height(childHeight);
        }
    
        $(window).resize(
            function() {
                adjustStickyHeader();
            }
        )

        var init = function() {
            ClusterService.initCluster($rs.userRole, 'hidden');
            $scope.getProductCategories();
            $scope.getProducts();
            adjustStickyHeader();
        };

        if ($rs.userRole && $rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    }]);